/**
 * External dependencies
 */
import { values } from 'lodash';
import { createSelector } from 'reselect';

/**
 * Inernal dependencies
 */
import getRawLayouts from './get-raw-layouts';

export default createSelector([getRawLayouts], (layouts) => values(layouts));
